/**
 * The feedback tab component that triggers the survey dialog
 */
import React from "react";
import { Nav } from "react-bootstrap";
import PropTypes from "prop-types";

const feedbackTabStyle = {
  position: "fixed",
  top: "50vh",
  right: "0",
  zIndex: 9999,
  transform: "rotate(90deg)",
  transformOrigin: "100% 0",
};

const feedbackLinkStyle = {
  fontSize: "1.5em",
  fontWeight: 400,
};

const FeedbackTab = (props) => {
  const { surveyAutoPopUp, questions, isOpen, handleOnClick, bluePrintStyle } =
    props;

  return (
    !surveyAutoPopUp &&
    questions.length > 0 &&
    !isOpen && (
      <aside
        id={`balto-feedback-tab`}
        aria-label={`balto-feedback-tab`}
        role={"complementary"}
      >
        <Nav
          variant="pills"
          activeKey={1}
          style={feedbackTabStyle}
          className={`balto-${bluePrintStyle}`}
        >
          <Nav.Item>
            <Nav.Link
              eventKey={1}
              style={feedbackLinkStyle}
              onClick={handleOnClick}
              id={"surveyFeedbackTab"}
            >
              Feedback
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </aside>
    )
  );
};

FeedbackTab.propTypes = {
  surveyAutoPopUp: PropTypes.bool.isRequired,
  questions: PropTypes.array,
  isOpen: PropTypes.bool.isRequired,
  handleOnClick: PropTypes.func.isRequired,
  bluePrintStyle: PropTypes.string,
};

export default FeedbackTab;
